<template>
  <v-card elevation="0" class="pa-3">
    <h2>New Project</h2>
    <div style="display: flex">
      <div style="flex: 1" class="mr-2">
        <h3>Project Name</h3>
        <v-text-field
          label="Project Name"
          name="name"
          type="text"
          autocomplete="off"
          v-model="name"
          outlined
          dense
          style="width: 350px"
          class="mt-2"
        />

        <h3>Domain</h3>
        <v-text-field
          label="Domain"
          name="domain"
          type="text"
          autocomplete="off"
          v-model="domain"
          outlined
          dense
          style="width: 350px"
          class="mt-2"
          suffix=".landly.page"
        />
        <v-alert border="left" text dense type="info" class="mt-2"
          >Don't worry, you can set up your custom domain later!</v-alert
        >
        <v-btn
          color="primary"
          @click="tryGenerateProject()"
          :loading="loading"
          elevation="0"
          :disabled="!name || !domain || loading"
          >Create Project</v-btn
        >
        <v-btn
          text
          @click="skipClick()"
          small
          class="ml-2"
          v-if="showSkipButton"
          >Skip</v-btn
        >
      </div>
      <div style="flex: 3">
        <NewProjectTemplateGenerator
          @blocks-generated="blocks = $event"
          @siteTheme-generated="siteTheme = $event"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import axios from "axios";
import NewProjectTemplateGenerator from "./NewProjectTemplateGenerator";

export default {
  components: {
    NewProjectTemplateGenerator,
  },
  props: ["showSkipButton"],
  data() {
    return {
      name: "",
      domain: "",
      loading: false,
      selectedTemplate: null,
      blocks: [],
      siteTheme: {},
    };
  },
  methods: {
    ...mapActions({
      generateProject: "project/generateProject",
    }),
    ...mapMutations(["ALERT_SUCCESS", "ALERT_ERROR"]),
    async tryGenerateProject() {
      if (!this.isValidDomain(this.domain + ".landly.page")) {
        this.ALERT_ERROR("Domain is not valid");
        return;
      }
      this.loading = true;
      const isAvailable = await this.checkIsDomainAvailable();
      if (isAvailable) {
        await this.generateProject({
          name: this.name,
          domain: this.domain,
          blocks: this.blocks.map((block) => {
            return {
              ...block,
              config: JSON.stringify(block.config),
            };
          }),
          siteTheme: JSON.stringify(this.siteTheme),
        });
      } else {
        this.ALERT_ERROR("Domain is not available");
      }
      this.loading = false;
    },
    isValidDomain(v) {
      if (!v) return false;
      var re =
        /^(?!:\/\/)([a-zA-Z0-9-]+\.){0,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?$/gi;
      return re.test(v);
    },
    async checkIsDomainAvailable() {
      const response = await axios.get(
        "/Console/IsDomainAvailable?domain=" + this.domain
      );
      return response.data.data === "OK";
    },
    skipClick() {
      this.$router.push("/");
    },
  },
};
</script>